/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const FAQIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-thoughts"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-thoughts:not(.animated) .animable {opacity: 0;}svg#freepik_stories-thoughts.animated #freepik--background-complete--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-thoughts.animated #freepik--Floor--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-thoughts.animated #freepik--Character--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-thoughts.animated #freepik--Plant--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-thoughts.animated #freepik--speech-bubble--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-3"
        style={{ transformOrigin: '244.2899990081787px 121.28524017333984px' }}
        className="animable"
      >
        <path
          d="M300.65,135.2a2,2,0,0,0-1.68,1.21l-3.62,8.92a1.93,1.93,0,0,0,1.58,2.65,6,6,0,0,1,4.1,2.44,5.43,5.43,0,0,1,1.09,4.15,5.56,5.56,0,0,1-2.5,3.53A6.2,6.2,0,0,1,295,159a7.23,7.23,0,0,1-5.17-7.39,1.94,1.94,0,0,0-3.86-.29,11.15,11.15,0,0,0,8.16,11.45,10,10,0,0,0,7.67-1.48,9.45,9.45,0,0,0,4.17-6.07,9.29,9.29,0,0,0-1.79-7.15,10.07,10.07,0,0,0-4.36-3.37l2.79-6.88a1.94,1.94,0,0,0-1.07-2.52A2.06,2.06,0,0,0,300.65,135.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '296.02015209198px 149.08962535858154px',
          }}
          id="ele2va9sfw1qi"
          className="animable"
        />
        <path
          d="M304.64,132.45a1.58,1.58,0,1,0-2.09.82A1.59,1.59,0,0,0,304.64,132.45Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '303.1889114379883px 131.82335531711578px',
          }}
          id="el1nb2rr4gp5f"
          className="animable"
        />
        <path
          d="M244.67,65.07a1.9,1.9,0,0,0-.3-2l-6.21-7.27a2,2,0,0,0-1.58-.67,2,2,0,0,0-1.48.86,5.93,5.93,0,0,1-4,2.49,5.34,5.34,0,0,1-4.16-.93,5.47,5.47,0,0,1-2-3.81,6.11,6.11,0,0,1,1.3-4.55A7.17,7.17,0,0,1,235.12,48a1.92,1.92,0,1,0,2-3.27,11.08,11.08,0,0,0-13.83,2,9.89,9.89,0,0,0-2.19,7.44,9.35,9.35,0,0,0,3.44,6.45,9.23,9.23,0,0,0,7.13,1.68,10,10,0,0,0,5-2.3l4.79,5.6a1.92,1.92,0,0,0,2.7.21A1.88,1.88,0,0,0,244.67,65.07Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '232.93099689483643px 54.71419715881348px',
          }}
          id="elywelxedq9r"
          className="animable"
        />
        <path
          d="M245.28,69.85a1.57,1.57,0,0,0,2.44-2,1.57,1.57,0,1,0-2.44,2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '246.49839901924133px 68.84803068637848px',
          }}
          id="eldszkzizn1z"
          className="animable"
        />
        <rect
          x="372.99"
          y="70.36"
          width="88.83"
          height="128.76"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '417.40500000000003px 134.74px',
          }}
          id="el5gkxbnba9rg"
          className="animable"
        />
        <rect
          x="368.54"
          y="70.36"
          width="88.83"
          height="128.76"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '412.95500000000004px 134.74px',
          }}
          id="elkl98xhe45n"
          className="animable"
        />
        <rect
          x="379.58"
          y="84.3"
          width="66.76"
          height="100.87"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '412.96px 134.735px',
          }}
          id="elae4e9ispnba"
          className="animable"
        />
        <path
          d="M446.34,185.17s0-.17,0-.49,0-.81,0-1.43c0-1.27,0-3.12,0-5.53,0-4.84,0-11.88-.06-20.78,0-17.79-.06-43-.1-72.64l.22.23-66.76,0h0l.24-.25c0,38.06,0,73.14-.05,100.87l-.19-.19,48.59.1,13.42,0,3.53,0,1.22,0s-.4,0-1.18,0l-3.49,0-13.38,0-48.71.11h-.2v-.2c0-27.73,0-62.81,0-100.87v-.24h.24l66.76,0h.22v.22c-.05,29.72-.08,55-.11,72.78,0,8.88-.05,15.91-.06,20.73,0,2.39,0,4.23,0,5.49,0,.61,0,1.08,0,1.41S446.34,185.17,446.34,185.17Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.0500030517578px 134.5150146484375px',
          }}
          id="elw4hawnegx3a"
          className="animable"
        />
        <path
          d="M457.62,70.36a15.58,15.58,0,0,1-1.58,2.3c-1,1.38-2.5,3.26-4.17,5.29s-3.23,3.82-4.39,5.1a14.73,14.73,0,0,1-2,2,16.66,16.66,0,0,1,1.69-2.21l4.28-5.19,4.27-5.19A16.79,16.79,0,0,1,457.62,70.36Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '451.5500030517578px 77.70500564575195px',
          }}
          id="elromjoqrb6en"
          className="animable"
        />
        <path
          d="M446.68,184.85a82.49,82.49,0,0,0,11.64,14.56"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '452.50001525878906px 192.13001251220703px',
          }}
          id="el0ur4hgv2zotb"
          className="animable"
        />
        <path
          d="M458.32,199.41a12.64,12.64,0,0,1-2-1.85,65,65,0,0,1-4.39-4.95,62.55,62.55,0,0,1-3.87-5.38,12.47,12.47,0,0,1-1.35-2.38,17.54,17.54,0,0,1,1.63,2.19c1,1.38,2.36,3.26,4,5.27s3.13,3.76,4.26,5A19.3,19.3,0,0,1,458.32,199.41Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '452.51499938964844px 192.12999725341797px',
          }}
          id="el4en094ey83n"
          className="animable"
        />
        <path
          d="M368.53,199l11.63-14.36"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '374.3450012207031px 191.81999969482422px',
          }}
          id="elxulvvq9wsgb"
          className="animable"
        />
        <path
          d="M380.16,184.66a85.09,85.09,0,0,1-5.63,7.33,89.58,89.58,0,0,1-6,7,83.31,83.31,0,0,1,5.63-7.33A89.58,89.58,0,0,1,380.16,184.66Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '374.34498596191406px 191.82500457763672px',
          }}
          id="elv9qcityks1"
          className="animable"
        />
        <path
          d="M368.54,70.36a83.13,83.13,0,0,1,5.65,6.75,83.17,83.17,0,0,1,5.27,7,78.55,78.55,0,0,1-5.65-6.75A80.62,80.62,0,0,1,368.54,70.36Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '374px 77.2349967956543px',
          }}
          id="elb54qgpuhfjb"
          className="animable"
        />
        <rect
          x="403.18"
          y="104.78"
          width="22.35"
          height="63.47"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '414.355px 136.515px',
          }}
          id="elc65yzw40xu7"
          className="animable"
        />
        <g id="elflvcb014jkc">
          <rect
            x="112.38"
            y="76.04"
            width="7.11"
            height="35.36"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '115.935px 93.72px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <g id="elol47jy5js68">
          <rect
            x="50.77"
            y="76.16"
            width="18.4"
            height="19.52"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '59.97px 85.92px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <g id="el50o93dpduz5">
          <rect
            x="69.09"
            y="76.06"
            width="18.4"
            height="19.52"
            style={{
              fill: 'rgb(245, 245, 245)',
              transformOrigin: '78.29px 85.82000000000001px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M50.75,81.6q18.35.15,36.72-.17a.2.2,0,0,0,0-.39C75.23,81,63,81,50.75,81.27a.16.16,0,1,0,0,.33Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '69.10527610778809px 81.33436778187752px',
          }}
          id="elo0rq4envy5h"
          className="animable"
        />
        <g id="elaeedmhqdrdo">
          <rect
            x="39.29"
            y="95.4"
            width="33.44"
            height="15.91"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '56.01px 103.355px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <g id="eltj5w55uvvl">
          <rect
            x="72.56"
            y="95.22"
            width="33.44"
            height="15.91"
            style={{
              fill: 'rgb(245, 245, 245)',
              transformOrigin: '89.28px 103.175px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M39.27,99.91c22.21.25,44.5,0,66.71-.33a.2.2,0,0,0,0-.39c-22.21-.12-44.51-.1-66.71.39a.16.16,0,0,0,0,.33Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '72.62028121948242px 99.57011210918427px',
          }}
          id="elrdsrkfoog6"
          className="animable"
        />
        <rect
          x="26.76"
          y="111.4"
          width="129.54"
          height="5.7"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '91.53px 114.25px',
          }}
          id="elvvrkdf4eocd"
          className="animable"
        />
        <rect
          x="47.97"
          y="114.14"
          width="5.26"
          height="19.45"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '50.6px 123.865px',
          }}
          id="el40nmgeloq0q"
          className="animable"
        />
        <rect
          x="126.47"
          y="114.14"
          width="5.26"
          height="19.45"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '129.1px 123.865px',
          }}
          id="elh6myex2h449"
          className="animable"
        />
        <g id="elgtwqyavt6ff">
          <rect
            x="119.35"
            y="62.85"
            width="7.11"
            height="48.64"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '122.905px 87.17px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <g id="elh3gt0vy0fcv">
          <rect
            x="126.49"
            y="71.92"
            width="11.04"
            height="39.41"
            style={{
              fill: 'rgb(245, 245, 245)',
              transformOrigin: '132.01px 91.625px',
              transform: 'rotate(-0.31deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M137.35,79.48a39.3,39.3,0,0,1-5.52.19,39.3,39.3,0,0,1-5.52-.19,39.3,39.3,0,0,1,5.52-.19A39.3,39.3,0,0,1,137.35,79.48Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.83000946044922px 79.48000884056091px',
          }}
          id="el8rdbtbpmq1c"
          className="animable"
        />
        <path
          d="M137.35,77.82a38.33,38.33,0,0,1-5.52.2,38.33,38.33,0,0,1-5.52-.2,41.21,41.21,0,0,1,5.52-.19A41.21,41.21,0,0,1,137.35,77.82Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.8300018310547px 77.82636314630508px',
          }}
          id="elnc3ycjdoa7f"
          className="animable"
        />
        <path
          d="M137.35,105.37a39.3,39.3,0,0,1-5.52.19,39.3,39.3,0,0,1-5.52-.19,39.3,39.3,0,0,1,5.52-.19A39.3,39.3,0,0,1,137.35,105.37Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.83000946044922px 105.37000666558743px',
          }}
          id="elgzjq5no4dee"
          className="animable"
        />
        <path
          d="M137.35,103.71a38.33,38.33,0,0,1-5.52.2,38.33,38.33,0,0,1-5.52-.2,41.21,41.21,0,0,1,5.52-.19A41.21,41.21,0,0,1,137.35,103.71Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.8300018310547px 103.71634943783283px',
          }}
          id="el0mt761pt15l"
          className="animable"
        />
        <path
          d="M132,100.1c-.1,0-.19-4-.19-8.88s.09-8.88.19-8.88.19,4,.19,8.88S132.12,100.1,132,100.1Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '132px 91.22000122070312px',
          }}
          id="elh64hl6ajbew"
          className="animable"
        />
        <rect
          x="137.47"
          y="81.57"
          width="12.02"
          height="29.75"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '143.48px 96.445px',
          }}
          id="elksucvd1q9co"
          className="animable"
        />
        <path
          d="M124.71,71.14a2,2,0,1,1-2-2A2,2,0,0,1,124.71,71.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '122.70999908447266px 71.13999938964844px',
          }}
          id="elt2cka1b7y2o"
          className="animable"
        />
        <rect
          x="122.04"
          y="76.76"
          width="1.26"
          height="28.93"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '122.67px 91.22500000000001px',
          }}
          id="elj247jngqyy8"
          className="animable"
        />
      </g>
      <g
        id="freepik--Floor--inject-3"
        style={{ transformOrigin: '250px 478.80999755859375px' }}
        className="animable"
      >
        <path
          d="M464,478.81c0,.15-95.82.26-214,.26S36,479,36,478.81s95.8-.26,214-.26S464,478.67,464,478.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250px 478.80999755859375px',
          }}
          id="elnrkhd1xypam"
          className="animable"
        />
      </g>
      <g
        id="freepik--Character--inject-3"
        style={{ transformOrigin: '229.37499237060547px 277.5037155151367px' }}
        className="animable"
      >
        <rect
          x="84.27"
          y="239.3"
          width="290.21"
          height="9.29"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '229.375px 243.94500000000002px',
          }}
          id="elypcxdqew39t"
          className="animable"
        />
        <polygon
          points="110.6 479.29 101.18 479.25 101.18 247.37 110.6 247.37 110.6 479.29"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '105.88999938964844px 363.3300018310547px',
          }}
          id="elyqvo1zimhwo"
          className="animable"
        />
        <polygon
          points="360.68 479.27 351.17 479.27 351.26 247.37 360.68 247.37 360.68 479.27"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '355.9250030517578px 363.3199920654297px',
          }}
          id="elqletqb0x6t"
          className="animable"
        />
        <path
          d="M196.73,153.86s51.8,54.27,50.89,66.32-12.51,14.65-16.29,14.18-32.27-32.18-32.27-32.18Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '222.18092155456543px 194.13569259643555px',
          }}
          id="elalvetshpv5p"
          className="animable"
        />
        <g id="el7i36kr0hr3x">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '222.18092155456543px 194.13569259643555px',
            }}
            className="animable"
          >
            <path
              d="M196.73,153.86s51.8,54.27,50.89,66.32-12.51,14.65-16.29,14.18-32.27-32.18-32.27-32.18Z"
              id="ellyl4rty5sz"
              style={{
                transformOrigin: '222.18092155456543px 194.13569259643555px',
              }}
              className="animable"
            />
          </g>
        </g>
        <polygon
          points="224.33 421.98 238.38 468.97 254.16 460.4 245.19 417.38 224.33 421.98"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '239.24500274658203px 443.1750030517578px',
          }}
          id="elzo4qfngig38"
          className="animable"
        />
        <path
          d="M252.23,439.72,257.06,462s24.24,2.56,25.53,6.58L239.8,479.47l-9-34.35Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '256.6949996948242px 459.5950012207031px',
          }}
          id="el4lyhcd4hm8t"
          className="animable"
        />
        <path
          d="M243.36,463.49a1.8,1.8,0,0,0-.7,2.3,1.72,1.72,0,0,0,2.27.71,1.9,1.9,0,0,0,.73-2.44,1.8,1.8,0,0,0-2.45-.48"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '244.16793489456177px 464.9858819246292px',
          }}
          id="el2d4nzmfl5py"
          className="animable"
        />
        <g id="el42qa7ho97qo">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '260.7799987792969px 473.1499938964844px',
            }}
            className="animable"
          >
            <path
              d="M239.8,479.47,239,476l41.32-9.17s2.11.35,2.24,1.74Z"
              id="elw53w1fm66sg"
              style={{
                transformOrigin: '260.7799987792969px 473.1499938964844px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M257.7,461.57c.05.21-1,.57-1.83,1.51s-1.18,1.95-1.39,1.91-.21-1.32.84-2.43S257.7,461.37,257.7,461.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '256.0359992980957px 463.23755753040314px',
          }}
          id="eloypnfwlydq8"
          className="animable"
        />
        <path
          d="M262.66,462.28c.1.19-.71.78-1.2,1.84s-.45,2.05-.66,2.1-.64-1.11,0-2.42S262.61,462.08,262.66,462.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '261.56567203998566px 464.22679579257965px',
          }}
          id="elj86i97fhm3s"
          className="animable"
        />
        <path
          d="M266.58,467c-.18.09-.73-.88-.49-2.16s1.11-2,1.24-1.83-.32.92-.5,2S266.79,466.93,266.58,467Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '266.691796541214px 464.9955677986145px',
          }}
          id="ellppjmt7fzal"
          className="animable"
        />
        <path
          d="M256,456.62c0,.22-1.08.17-2.24.55s-2,1-2.14.84.54-1.12,1.92-1.55S256.1,456.43,256,456.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '253.8039562702179px 457.1519228219986px',
          }}
          id="elp3zumo147b"
          className="animable"
        />
        <path
          d="M255,452.15a4.1,4.1,0,0,1-2.15.54,9.85,9.85,0,0,1-2.42-.12,8.27,8.27,0,0,1-1.39-.34,2.63,2.63,0,0,1-.78-.33.94.94,0,0,1-.38-1.09,1.17,1.17,0,0,1,.79-.71,2.94,2.94,0,0,1,.84-.1,8.31,8.31,0,0,1,1.44.12,7.62,7.62,0,0,1,2.31.79c1.23.67,1.77,1.36,1.71,1.42s-.73-.44-1.93-.94a9.12,9.12,0,0,0-2.19-.59,8.25,8.25,0,0,0-1.33-.06c-.48,0-.87.09-.93.32s0,.12.11.23a2.05,2.05,0,0,0,.57.25,11.31,11.31,0,0,0,1.29.35,12.73,12.73,0,0,0,2.28.27A16.87,16.87,0,0,1,255,452.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.41523361206055px 451.3579611778259px',
          }}
          id="el61kezx84y5v"
          className="animable"
        />
        <path
          d="M254.78,452.52c-.06.05-.67-.59-1.09-1.92a7.11,7.11,0,0,1-.31-2.42,7.57,7.57,0,0,1,.21-1.45,1.86,1.86,0,0,1,1.1-1.43,1,1,0,0,1,1,.37,2.94,2.94,0,0,1,.42.73,4.56,4.56,0,0,1,.37,1.45,5,5,0,0,1-.35,2.44c-.55,1.33-1.36,1.8-1.39,1.73a17.7,17.7,0,0,0,.89-1.9,5.14,5.14,0,0,0,.17-2.19,4.66,4.66,0,0,0-.36-1.23c-.18-.44-.45-.76-.6-.67s-.49.49-.57.89a6.88,6.88,0,0,0-.24,1.3,7.93,7.93,0,0,0,.13,2.24C254.46,451.74,254.89,452.46,254.78,452.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '254.94059562683105px 448.9005661010742px',
          }}
          id="el1p6gdky94mz"
          className="animable"
        />
        <path
          d="M186.2,288c.52,2.08,37.2,151.75,37.2,151.75l33.31-10.06-31.45-151.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '221.45499420166016px 358.9199981689453px',
          }}
          id="el3uenqncxbyu"
          className="animable"
        />
        <path
          d="M181.29,96.75l-5.82,44.72a13.42,13.42,0,0,0,12.23,15.1h0a13.42,13.42,0,0,0,14.38-11.66c.43-3.37.8-6.17.87-6.52,0,0,11.53.42,13.81-10.74,1.11-5.4,2.48-16.69,3.61-26.92a21.22,21.22,0,0,0-17.1-23.15l-1.08-.21C190.42,75.81,182.53,84.94,181.29,96.75Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '197.92812538146973px 116.90468978881836px',
          }}
          id="elnuys9tcu6f"
          className="animable"
        />
        <path
          d="M203,138.24a26.56,26.56,0,0,1-13.79-7s1.9,8.71,13.26,9.85Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '196.1050033569336px 136.16500854492188px',
          }}
          id="eljlsxell3f8"
          className="animable"
        />
        <path
          d="M217.17,107.05a1.63,1.63,0,0,1-1.85,1.31A1.56,1.56,0,0,1,214,106.6a1.62,1.62,0,0,1,1.85-1.31A1.56,1.56,0,0,1,217.17,107.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '215.58500814437866px 106.82429885864258px',
          }}
          id="elc6j523wl0zt"
          className="animable"
        />
        <path
          d="M217.26,105.12c-.23.17-1.27-1-3-1.28s-3.15.29-3.29,0,.2-.45.82-.74a4.53,4.53,0,0,1,2.69-.29,4.21,4.21,0,0,1,2.33,1.28C217.27,104.64,217.38,105.05,217.26,105.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '214.1218671798706px 103.93009829521179px',
          }}
          id="ellrv7gw4wgw"
          className="animable"
        />
        <path
          d="M199.88,104.59a1.64,1.64,0,0,1-1.86,1.32,1.56,1.56,0,0,1-1.37-1.76,1.63,1.63,0,0,1,1.85-1.31A1.56,1.56,0,0,1,199.88,104.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '198.26428365707397px 104.3749223947525px',
          }}
          id="el1kc8m4xl74c"
          className="animable"
        />
        <path
          d="M200.07,102.42c-.24.17-1.28-1-3-1.28s-3.15.29-3.3,0,.2-.44.83-.74a4.49,4.49,0,0,1,2.68-.29,4.31,4.31,0,0,1,2.34,1.28C200.08,101.94,200.19,102.35,200.07,102.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '196.92525029182434px 101.22993040084839px',
          }}
          id="elh1qclz87qpb"
          className="animable"
        />
        <path
          d="M203.74,116.78a11.51,11.51,0,0,1,2.89,0c.44,0,.88,0,1-.26a2.32,2.32,0,0,0,0-1.35l-.66-3.6c-.89-5.1-1.44-9.27-1.24-9.3s1.1,4.08,2,9.18c.2,1.26.4,2.46.59,3.61a2.57,2.57,0,0,1-.1,1.76,1.14,1.14,0,0,1-.85.51,3.6,3.6,0,0,1-.76,0A12.54,12.54,0,0,1,203.74,116.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '206.08488202095032px 109.80997657775879px',
          }}
          id="eldtv5eyu7jot"
          className="animable"
        />
        <path
          d="M201.25,98.92c-.26.44-1.93-.11-4-.26s-3.8.09-4-.38c-.09-.22.28-.61,1-.93a6.59,6.59,0,0,1,3.1-.46,6.67,6.67,0,0,1,3,.94C201.06,98.28,201.37,98.71,201.25,98.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '197.25594806671143px 97.97448265552521px',
          }}
          id="el8cepawcg65t"
          className="animable"
        />
        <path
          d="M218.06,98.87c-.38.33-1.49-.31-2.91-.6s-2.68-.24-2.88-.7c-.08-.22.18-.58.78-.85a4.31,4.31,0,0,1,4.66,1C218.14,98.27,218.23,98.7,218.06,98.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '215.1983187198639px 97.69169247150421px',
          }}
          id="el6ar1wgblewr"
          className="animable"
        />
        <path
          d="M180.62,105.21c-.18-.12-7.25-3.75-8.48,3.94s6.75,7.34,6.8,7.12S180.62,105.21,180.62,105.21Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '176.31557607650757px 110.30193424224854px',
          }}
          id="elifsc984oxu"
          className="animable"
        />
        <path
          d="M177.05,113s-.14.07-.39.14a1.3,1.3,0,0,1-1-.14c-.77-.42-1.25-1.82-1.06-3.22a4.46,4.46,0,0,1,.68-1.86,1.54,1.54,0,0,1,1.17-.86.69.69,0,0,1,.73.49c.07.23,0,.38,0,.4s.18-.11.17-.43a.9.9,0,0,0-.23-.54,1.09,1.09,0,0,0-.71-.31,1.92,1.92,0,0,0-1.59,1,4.59,4.59,0,0,0-.8,2.07c-.2,1.56.36,3.14,1.42,3.64a1.5,1.5,0,0,0,1.26,0C177,113.17,177.08,113,177.05,113Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '175.6651487350464px 110.09435415267944px',
          }}
          id="ell2w1w1uh5br"
          className="animable"
        />
        <path
          d="M176.41,104.13a4.1,4.1,0,0,1,3.32,2.6c.29,1.18.16,2.44.44,3.63s1.22,2.39,2.44,2.34a2.41,2.41,0,0,0,1.93-1.44,6.63,6.63,0,0,0,.5-2.46c.23-3.66.16-7.35.71-11a18.74,18.74,0,0,1,4.26-10c2.48-2.7,6.38-4.28,9.91-3.3,2.34.64,4.28,2.3,6.58,3.09a9.51,9.51,0,0,0,8.26-1.1,2.56,2.56,0,0,1,.42-.22,2.09,2.09,0,0,0,1.19-2.25,1.92,1.92,0,0,0-.31-.82C212.21,78,204,75.2,197.52,75.57s-13.13,3.62-16.91,8.91-4.54,13.5-4.2,19.65"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '196.36840629577637px 94.11947441101074px',
          }}
          id="elqamn9z6bfa"
          className="animable"
        />
        <path
          d="M207.2,122a12.14,12.14,0,0,1-4.7-1.73,6.09,6.09,0,0,1,2.44.62A6.16,6.16,0,0,1,207.2,122Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '204.8499984741211px 121.13499450683594px',
          }}
          id="el534fo30l67j"
          className="animable"
        />
        <path
          d="M215.56,130.62a4.89,4.89,0,0,1-.95,2.08,11.67,11.67,0,0,1-4.18,3.6,19.7,19.7,0,0,1-5.21,1.78,7.93,7.93,0,0,1-2.26.29,13.57,13.57,0,0,1,2.17-.65,25.53,25.53,0,0,0,5.06-1.88,12.8,12.8,0,0,0,4.12-3.36C215.16,131.39,215.48,130.58,215.56,130.62Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '209.26000213623047px 134.49482083320618px',
          }}
          id="el9nxvoslu956"
          className="animable"
        />
        <path
          d="M210.14,136.33c-2.71,1.35-4.7,5-6.42,7.42a5.91,5.91,0,0,0-1.22,2.39,5.55,5.55,0,0,0,.49,2.79c.49,1.33,1,2.64,1.6,3.94.16.38.37.79.77.88s.92-.38,1.13-.85a13.83,13.83,0,0,0,.63-3.76A3.91,3.91,0,0,1,209,146"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '206.31017136573792px 145.04558086395264px',
          }}
          id="elujwcz11j43p"
          className="animable"
        />
        <path
          d="M214.42,146.31l-2.63-2a.79.79,0,0,0-1.1.09l-1.4,1.62h0l.74,4.09c.86,5.25-3,4.43-3,4.43l-.31-1-1.71-6.4c-.34-3.06-.1-3.42,1.39-5.63l3.26-4.66a2.62,2.62,0,0,1,3.09-1c4.68,1.73,14.77,4.85,15.91,8.82,2.07,7.22,3.74,25.65,3.77,26h0L218.14,172h0l.07-12.29a6.41,6.41,0,0,1-2.68-3.38c-.6-2.17-1.11-10-1.11-10"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '218.65206813812256px 153.84294891357422px',
          }}
          id="el3w02ug3tyid"
          className="animable"
        />
        <path
          d="M224.29,148.72s-.15.25-.54.58a4.57,4.57,0,0,1-1.94,1,3.53,3.53,0,0,1-1.55,0,2.77,2.77,0,0,1-1.52-1c-.84-1-1-2.42-1.7-3.45a6.69,6.69,0,0,0-1.47-1.21,14.22,14.22,0,0,0-1.6-.89,2.88,2.88,0,0,0-1.46-.41,3,3,0,0,0-1.16.69c-1.29,1.19-2,2.09-2.07,2s.13-.25.43-.66a14.4,14.4,0,0,1,1.39-1.63,3.25,3.25,0,0,1,1.32-.83,1.27,1.27,0,0,1,.48,0,3.15,3.15,0,0,1,.44.11,5.26,5.26,0,0,1,.83.32,11.74,11.74,0,0,1,1.67.89,6.63,6.63,0,0,1,1.62,1.33c.84,1.22.94,2.61,1.65,3.46a2.73,2.73,0,0,0,2.63.9,5,5,0,0,0,1.89-.78C224,148.86,224.26,148.69,224.29,148.72Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '216.77797746658325px 146.63661670684814px',
          }}
          id="elf44awsrezad"
          className="animable"
        />
        <path
          d="M222.71,153.06a18.38,18.38,0,0,1-7.79-2.25,24.09,24.09,0,0,1,3.92,1.06A24.59,24.59,0,0,1,222.71,153.06Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '218.8150177001953px 151.93500518798828px',
          }}
          id="el9u8lekkt51"
          className="animable"
        />
        <path
          d="M217.64,146.37c-3.74,0-4.18-.17-8.41.06a6.14,6.14,0,0,0-1.86.3,2,2,0,0,0-1.28,1.3c-.29,1.16.88,2.21,2,2.48s2.4.06,3.56.33a7.82,7.82,0,0,1,4.69,2.75c2.44,3.45,5,1.79,6.66,3l4.36-2.76-1.54-6.44-8.22-1"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '216.7026023864746px 151.4497528076172px',
          }}
          id="elmp0tes1id0l"
          className="animable"
        />
        <path
          d="M223.42,156.62a4.75,4.75,0,0,0-1.19-.37,10.89,10.89,0,0,1-3.46-.61,5.58,5.58,0,0,1-1.9-1.57,6.54,6.54,0,0,0-1.93-1.84,9.83,9.83,0,0,0-2.74-1.1,24.14,24.14,0,0,0-3.23-.28,3.12,3.12,0,0,1-2.73-2,1.76,1.76,0,0,1,.42-1.68,2.76,2.76,0,0,1,1.39-.81,17.87,17.87,0,0,1,2.8-.23c.86,0,1.67,0,2.41,0,1.48,0,2.66.1,3.48.14a6.66,6.66,0,0,1,1.28.1,5.09,5.09,0,0,1-1.28.1c-.82,0-2,0-3.48,0-.73,0-1.53,0-2.39.09a16.77,16.77,0,0,0-2.7.26c-.85.18-1.72,1-1.44,1.88a2.63,2.63,0,0,0,2.31,1.6,23,23,0,0,1,3.28.3,10,10,0,0,1,2.88,1.2,6.72,6.72,0,0,1,2,2,5.28,5.28,0,0,0,1.73,1.51,12.39,12.39,0,0,0,3.33.74,2.6,2.6,0,0,1,.91.35C223.35,156.53,223.43,156.6,223.42,156.62Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '214.79867362976074px 151.375px',
          }}
          id="elceo0w8hvkdt"
          className="animable"
        />
        <path
          d="M217.22,143.45c0-.06.27-.11.66.06a1.71,1.71,0,0,1,.4,2.81c-.32.28-.59.3-.62.24s.16-.2.35-.48a1.8,1.8,0,0,0,.31-1.2,1.7,1.7,0,0,0-.63-1C217.43,143.61,217.21,143.53,217.22,143.45Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '218.03262329101562px 144.9906713962555px',
          }}
          id="elfb9gpxjj4wd"
          className="animable"
        />
        <polygon
          points="225.59 311.08 207.35 356.61 225.05 359.72 244.79 320.45 225.59 311.08"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '226.06999969482422px 335.3999938964844px',
          }}
          id="elm1rk9x228u"
          className="animable"
        />
        <path
          d="M236.39,342.32l-10,20.43s17.38,17.07,15.89,21l-40.3-18.07,14.35-32.46Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '222.17530059814453px 358.48500061035156px',
          }}
          id="eljxuqxk01bun"
          className="animable"
        />
        <path
          d="M214.67,355.42a1.79,1.79,0,0,0-2,1.36,1.73,1.73,0,0,0,1.33,2,1.9,1.9,0,0,0,2.09-1.46,1.79,1.79,0,0,0-1.62-1.9"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '214.36781001091003px 357.0981351137161px',
          }}
          id="el6iv0eiy1ia"
          className="animable"
        />
        <g id="eltm4slqgtkc">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '222.20326614379883px 373.1000061035156px',
            }}
            className="animable"
          >
            <path
              d="M201.94,365.71l1.45-3.27L241.57,381s1.44,1.58.67,2.76Z"
              id="el4ze9lsxhec"
              style={{
                transformOrigin: '222.20326614379883px 373.1000061035156px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M227.09,362.83c-.09.2-1.12-.15-2.37.05s-2.14.79-2.28.63.65-1.16,2.17-1.38S227.21,362.67,227.09,362.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.7615954875946px 362.81375098228455px',
          }}
          id="elnhjl611ys7l"
          className="animable"
        />
        <path
          d="M230.53,366.48c0,.21-1,.16-2.08.69s-1.63,1.33-1.82,1.23.18-1.26,1.49-1.9S230.61,366.29,230.53,366.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '228.55860579013824px 367.28515923023224px',
          }}
          id="elw268jbcb1ha"
          className="animable"
        />
        <path
          d="M230.67,372.61c-.2,0,0-1.14,1-2s2.11-.87,2.12-.67-.82.52-1.62,1.23S230.87,372.68,230.67,372.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.19519984722137px 371.2238681316376px',
          }}
          id="elfom10zzwal6"
          className="animable"
        />
        <path
          d="M228.86,357.93c-.16.14-.94-.54-2.09-1s-2.17-.46-2.19-.68,1.12-.54,2.46,0S229,357.81,228.86,357.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '226.729558467865px 356.95096921920776px',
          }}
          id="elsd0vxyq585"
          className="animable"
        />
        <path
          d="M230.82,353.77a4.22,4.22,0,0,1-2-.92,9.74,9.74,0,0,1-1.82-1.59,9.53,9.53,0,0,1-.88-1.14,2.5,2.5,0,0,1-.4-.75.92.92,0,0,1,.38-1.08,1.18,1.18,0,0,1,1.06-.07,3.11,3.11,0,0,1,.71.45,8.53,8.53,0,0,1,1.07,1,7.81,7.81,0,0,1,1.31,2.06,3.59,3.59,0,0,1,.45,2.17c-.12,0-.3-.8-.93-1.94a8.44,8.44,0,0,0-1.34-1.82,9.66,9.66,0,0,0-1-.88c-.38-.3-.74-.47-.93-.32s-.09.08-.06.24a2.11,2.11,0,0,0,.29.55,13.27,13.27,0,0,0,.79,1.09,13,13,0,0,0,1.62,1.62C230.13,353.27,230.87,353.66,230.82,353.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '228.24584531784058px 351.0131821632385px',
          }}
          id="el7al0ndw5oep"
          className="animable"
        />
        <path
          d="M230.43,353.93a3.51,3.51,0,0,1,.34-2.18,7.1,7.1,0,0,1,1.27-2.09,7.26,7.26,0,0,1,1.06-1,1.85,1.85,0,0,1,1.75-.44,1.07,1.07,0,0,1,.59.94,3,3,0,0,1-.13.84,4.93,4.93,0,0,1-.6,1.36,5.3,5.3,0,0,1-1.8,1.7,2.87,2.87,0,0,1-2.17.48,19.42,19.42,0,0,0,1.89-.93,5.24,5.24,0,0,0,1.49-1.62,4.78,4.78,0,0,0,.48-1.18c.13-.45.12-.87-.06-.9a1.31,1.31,0,0,0-1,.34,7.69,7.69,0,0,0-1,.87,8.06,8.06,0,0,0-1.29,1.84C230.67,353.12,230.55,354,230.43,353.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.9111466407776px 351.0451054573059px',
          }}
          id="elb2pwfw60vdh"
          className="animable"
        />
        <path
          d="M190.68,256.48,246.84,229a24.89,24.89,0,0,1,29.24,5.47h0a24.9,24.9,0,0,1,4.09,27.77l-37.26,76.62L211.74,329l27.41-58.4-30.84,23.5A48.46,48.46,0,0,1,179.36,304l-8.08.07a38.77,38.77,0,0,1-32.33-20h0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '210.81359100341797px 282.6604232788086px',
          }}
          id="elyn5vuskwcm"
          className="animable"
        />
        <path
          d="M242.91,338.84s-.2,0-.58-.15l-1.65-.49-6.29-1.92-22.72-7.07-.22-.07.1-.22c5.5-11.76,12.36-26.41,19.77-42.26,2.63-5.58,5.18-11,7.6-16.16l.38.31c-14.14,10.54-26.8,19.29-36.14,25.05a97.94,97.94,0,0,1-11.3,6.18,17.67,17.67,0,0,1-3.28,1.11,4.76,4.76,0,0,1-.89.12h-.3s.41,0,1.17-.22a19.8,19.8,0,0,0,3.23-1.18,104.88,104.88,0,0,0,11.2-6.3c9.28-5.83,21.89-14.63,36-25.17l.82-.61-.43.92c-2.42,5.15-5,10.58-7.58,16.16-7.45,15.84-14.34,30.47-19.87,42.22l-.13-.29,22.66,7.24,6.26,2,1.63.55Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '215.15001678466797px 304.3149719238281px',
          }}
          id="elt1igrbp1ax"
          className="animable"
        />
        <path
          d="M249.71,257.92a32.88,32.88,0,0,0-6.47,5.57,32.35,32.35,0,0,0-4.35,7.35,8.32,8.32,0,0,1,.74-2.43,20.83,20.83,0,0,1,7.81-9.33A8.19,8.19,0,0,1,249.71,257.92Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '244.29999542236328px 264.3800048828125px',
          }}
          id="eln1ebs0nmyui"
          className="animable"
        />
        <path
          d="M130.65,366.34h80.78a2.07,2.07,0,0,1,2.08,2h0a2.09,2.09,0,0,1-2.08,2.14H130.65a2.08,2.08,0,0,1-2.07-2.08h0A2.07,2.07,0,0,1,130.65,366.34Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '171.04529190063477px 368.4099886417389px',
          }}
          id="elyd59lkc5wv"
          className="animable"
        />
        <path
          d="M200.81,314.91H137.62a12.24,12.24,0,0,1,12.24-12.24h38.7a12.24,12.24,0,0,1,12.25,12.24Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '169.2150115966797px 308.7900104522705px',
          }}
          id="elhkhaymxma8b"
          className="animable"
        />
        <rect
          x="136.13"
          y="314.91"
          width="66.66"
          height="3.71"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '169.45999999999998px 316.76500000000004px',
          }}
          id="elvo0ta6mspzg"
          className="animable"
        />
        <polygon
          points="142.06 318.63 125.76 479.29 129.6 479.29 149.49 318.63 142.06 318.63"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '137.62500381469727px 398.9600067138672px',
          }}
          id="elbiwynm94szf"
          className="animable"
        />
        <polygon
          points="196.36 318.63 212.65 479.21 208.82 479.23 188.94 318.69 196.36 318.63"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '200.7949981689453px 398.9300079345703px',
          }}
          id="el3lfrd7xsoes"
          className="animable"
        />
        <polygon
          points="173.66 317.21 170.91 479.28 166.98 479.28 165.26 316.77 173.66 317.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '169.45999908447266px 398.0249938964844px',
          }}
          id="el3ggyenstee9"
          className="animable"
        />
        <polygon
          points="172.38 141.07 176.34 129.05 202.47 141.14 201.27 153.86 188.25 157.56 175.47 149.73 172.38 141.07"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '187.4250030517578px 143.30500030517578px',
          }}
          id="el1w9rgs7yh92"
          className="animable"
        />
        <path
          d="M139,284.1a8.68,8.68,0,0,1-3.66-7.29c0-4.82,4.3-5.22,4.44-7.89,1.43-27.55,4.55-84.62,6.61-102.63,2.59-22.7,29.19-27.49,29.19-27.49l21.95,5.39v1.66c7.6,9.77,10.89,24.5,10.9,36.88l-1,65.58Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '171.8837547302246px 211.44998931884766px',
          }}
          id="eledft50qznyk"
          className="animable"
        />
        <path
          d="M163.63,247.37a7.46,7.46,0,0,1-.82,1.12c-.54.7-1.37,1.69-2.41,2.89-2.08,2.41-5.07,5.64-8.59,9s-6.88,6.2-9.38,8.16c-1.26,1-2.28,1.76-3,2.28a6.48,6.48,0,0,1-1.16.76,6.78,6.78,0,0,1,1-.92l2.89-2.4c2.44-2,5.76-4.91,9.26-8.26s6.53-6.52,8.68-8.86l2.53-2.79A6.67,6.67,0,0,1,163.63,247.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '150.9499969482422px 259.4750061035156px',
          }}
          id="elzhwtfu567nf"
          className="animable"
        />
        <g id="elnr8op9znt1a">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '150.8747148513794px 259.1800003051758px',
            }}
            className="animable"
          >
            <path
              d="M142,268.83c.08-4.15,3.19-7.57,6.27-10.36a101.34,101.34,0,0,1,11.46-9c.2,2-1.18,3.83-2.52,5.37a108.09,108.09,0,0,1-14.88,14.05"
              id="el2noi3hw7jqy"
              style={{
                transformOrigin: '150.8747148513794px 259.1800003051758px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M180.43,139.08a12.21,12.21,0,0,1,.81-3.49,12.38,12.38,0,0,1,1.3-3.33,12.21,12.21,0,0,1-.81,3.49A12.78,12.78,0,0,1,180.43,139.08Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '181.48500061035156px 135.6699981689453px',
          }}
          id="elcbouwffhtd"
          className="animable"
        />
        <path
          d="M190.62,135.67a11.7,11.7,0,0,1-.53,3.47,12.08,12.08,0,0,1-1,3.35,11.74,11.74,0,0,1,.53-3.47A12.08,12.08,0,0,1,190.62,135.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.85499572753906px 139.0800018310547px',
          }}
          id="el77eat1duvua"
          className="animable"
        />
        <path
          d="M198.21,139.46a13.66,13.66,0,0,1-.27,3.15,14,14,0,0,1-.46,3.14,7.62,7.62,0,0,1,0-3.2A7.75,7.75,0,0,1,198.21,139.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '197.7632408440113px 142.60501098632812px',
          }}
          id="eliqtmcjmx19h"
          className="animable"
        />
        <path
          d="M171.83,203.64a4.39,4.39,0,0,1-1.1.08c-.72,0-1.75,0-3,0-2.55,0-6.07,0-10-.11s-7.42-.17-10-.27c-1.28,0-2.31-.09-3-.14a4.24,4.24,0,0,1-1.11-.12,5.35,5.35,0,0,1,1.11-.08c.72,0,1.75,0,3,0,2.55,0,6.07,0,10,.11s7.42.16,10,.26l3,.14A4.11,4.11,0,0,1,171.83,203.64Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '157.7249984741211px 203.36171925067902px',
          }}
          id="el0h4wan8a4nxu"
          className="animable"
        />
        <path
          d="M166.26,195.25c0,.15-5,.15-11.2,0s-11.18-.35-11.18-.5,5-.15,11.19,0S166.26,195.11,166.26,195.25Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '155.06999969482422px 195.00000762939453px',
          }}
          id="elxqugc3vmff7"
          className="animable"
        />
        <g id="el6557lzq1329">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '182.11000061035156px 212.5875244140625px',
            }}
            className="animable"
          >
            <path
              d="M156.75,182.32c8,17.42,17.78,33.06,29.15,48.48,2.93,4,6.07,8,10.3,10.49s7,1.83,11.27-.72c-4.73-1.51-6-2-10-4.89a47.84,47.84,0,0,1-10.09-10.77c-10-13.76-19.76-27.93-29.78-41.69"
              id="elji7zcwdzd8"
              style={{
                transformOrigin: '182.11000061035156px 212.5875244140625px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M239.92,207.09a9.72,9.72,0,0,1,.93-3.33,3.3,3.3,0,0,1,2.76-1.84,2,2,0,0,1,2,2.27,5,5,0,0,1-1.11,1.7c-1.27,1.74-1.15,4.09-1.14,6.24s-.26,4.61-2,5.9"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '242.7741596698761px 209.97495651245117px',
          }}
          id="elr0j5zujm78g"
          className="animable"
        />
        <path
          d="M160.58,156.89a18.16,18.16,0,0,0-4.06,25.87l36.54,48.12a27.39,27.39,0,0,0,33.75,7.91h0a27.4,27.4,0,0,0,15.3-26.07l-8.05-50.6-19.66,1.22,1.86,41.21-30.42-43.23a18.17,18.17,0,0,0-25.26-4.43Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '197.48551559448242px 197.59566497802734px',
          }}
          id="elpepmz868lso"
          className="animable"
        />
        <path
          d="M239.34,227.07c-4.84-1.13-5.66-2-10.49-3.09-1.44-.34-3.29-1.27-2.65-2.8a2.07,2.07,0,0,1,2.06-1.2c1.88.16,4.91,1.28,6.73,1.45.45,0,.44-.41.24-.72a57.08,57.08,0,0,0-9-1.94,2.22,2.22,0,0,1-1.11-3.92,3.47,3.47,0,0,1,1.29-.37c1.94.28,1.94.28,4,.64,5.79,1,5-.14,5-.14,0-.44-6.59-1.08-10-1.49a2.94,2.94,0,0,1-2-.76,1.92,1.92,0,0,1,.23-2.41,3.38,3.38,0,0,1,2.33-1.17c3.77-.07,16.15,1.31,16.15,1.31s1.62,2.2,1.12,6.71C242.73,222.11,239.34,227.07,239.34,227.07Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '233.2121753692627px 218.10870933532715px',
          }}
          id="elf3p7aoxv0ik"
          className="animable"
        />
        <path
          d="M221.83,240.57s-.18,0-.52.08l-1.54.16c-1.36.12-3.36.31-6,.34a28.94,28.94,0,0,1-9.32-1.29,26.27,26.27,0,0,1-10.29-7,136.58,136.58,0,0,1-9.65-11.64c-3.29-4.33-6.73-9-10.31-13.95s-7.28-10.18-11.09-15.63l-5.77-8.33c-.49-.71-1-1.42-1.46-2.14l-.7-1.11a10,10,0,0,1-.63-1.16,17.69,17.69,0,0,1-1.64-5.05,17.21,17.21,0,0,1-.1-5.31,20.77,20.77,0,0,1,.5-2.59,21.21,21.21,0,0,1,.89-2.46,19.29,19.29,0,0,1,1.2-2.3,18.56,18.56,0,0,1,1.53-2.08,17.87,17.87,0,0,1,3.77-3.4,19.25,19.25,0,0,1,4.48-2.21,18.59,18.59,0,0,1,4.82-.87,18.31,18.31,0,0,1,9.19,2,18.68,18.68,0,0,1,6.71,5.92q2.48,3.56,4.79,6.92l8.6,12.42,12.42,18,3.36,4.91c.37.55.65,1,.86,1.28l.28.45a5.07,5.07,0,0,1-.33-.42l-.9-1.25L211.6,198,199,180.11l-8.65-12.39-4.82-6.9a18.25,18.25,0,0,0-6.55-5.75,17.89,17.89,0,0,0-13.63-1,18.78,18.78,0,0,0-4.35,2.16,16.9,16.9,0,0,0-3.67,3.3,18.36,18.36,0,0,0-1.48,2,17.6,17.6,0,0,0-1.16,2.24,18.44,18.44,0,0,0-.87,2.39,19.34,19.34,0,0,0-.49,2.52,17.68,17.68,0,0,0,1.7,10,36.5,36.5,0,0,0,2.74,4.35l5.77,8.34c3.8,5.45,7.5,10.68,11.06,15.63s7,9.64,10.26,14a139.3,139.3,0,0,0,9.58,11.65,26.19,26.19,0,0,0,10.11,7,29.13,29.13,0,0,0,9.23,1.36c2.58,0,4.58-.16,5.94-.25l1.54-.1C221.65,240.57,221.83,240.57,221.83,240.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '187.24045944213867px 196.8853416442871px',
          }}
          id="elosvihgepoi"
          className="animable"
        />
        <path
          d="M218.35,219.65a21.24,21.24,0,0,0-2.52-15.82,7.21,7.21,0,0,1,1.41,2,17.06,17.06,0,0,1,1.91,5.59,17.25,17.25,0,0,1-.08,5.9A7.24,7.24,0,0,1,218.35,219.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '217.59786903858185px 211.739990234375px',
          }}
          id="elznmjqcd7jn"
          className="animable"
        />
        <path
          d="M218.84,168.71a5.37,5.37,0,0,1-.7-2.7,5.43,5.43,0,0,1,.24-2.78,12.4,12.4,0,0,1,.28,2.74A12.17,12.17,0,0,1,218.84,168.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '218.4559806585312px 165.97000885009766px',
          }}
          id="eliwn8xaawdq"
          className="animable"
        />
        <path
          d="M224.26,168.21a8.12,8.12,0,0,1-.7-5.37,11.71,11.71,0,0,1,.4,2.68A12.06,12.06,0,0,1,224.26,168.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '223.82051181793213px 165.52500915527344px',
          }}
          id="elvt9zis2mz5m"
          className="animable"
        />
        <path
          d="M229.63,167a4.75,4.75,0,0,1-.38-2.2,4.94,4.94,0,0,1,.14-2.23,4.91,4.91,0,0,1,.38,2.2A5.11,5.11,0,0,1,229.63,167Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '229.50798553228378px 164.7850112915039px',
          }}
          id="elxhxhenikowp"
          className="animable"
        />
        <path
          d="M196.52,178.19c.08.11-6.12,4.55-13.85,9.91s-14.06,9.61-14.15,9.49,6.12-4.56,13.85-9.92S196.44,178.07,196.52,178.19Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '182.5199089050293px 187.8900022506714px',
          }}
          id="elqf4d8sx2bop"
          className="animable"
        />
        <path
          d="M191.68,170.93a6.82,6.82,0,0,1-1.09.84l-3.05,2.14c-2.59,1.8-6.14,4.32-10,7.17s-7.3,5.53-9.78,7.47c-1.18.93-2.16,1.7-2.94,2.3a6.57,6.57,0,0,1-1.12.8,6.58,6.58,0,0,1,1-1c.66-.59,1.63-1.42,2.84-2.43,2.42-2,5.83-4.74,9.7-7.6s7.46-5.34,10.1-7.07c1.32-.86,2.39-1.55,3.15-2A6.77,6.77,0,0,1,191.68,170.93Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '177.69000244140625px 181.28998565673828px',
          }}
          id="elcyoq9213f2c"
          className="animable"
        />
      </g>
      <g
        id="freepik--Plant--inject-3"
        style={{ transformOrigin: '396.7994689941406px 386.5484161376953px' }}
        className="animable"
      >
        <rect
          x="363.77"
          y="421.65"
          width="68.04"
          height="9.35"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.78999999999996px 426.325px',
          }}
          id="eleuwcd733vxl"
          className="animable"
        />
        <path
          d="M431.92,431.11H363.65v-9.58h68.27Zm-68-.23h67.81v-9.12H363.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.7850036621094px 426.3199920654297px',
          }}
          id="elg5eeg113wxh"
          className="animable"
        />
        <polygon
          points="370.07 427.88 379.87 476.2 416.11 476.2 425.57 431 370.07 427.88"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.82000732421875px 452.0400085449219px',
          }}
          id="elgxffh8gdn6f"
          className="animable"
        />
        <polygon
          points="370.07 471.63 375.3 478.81 419.35 478.81 425.57 471.63 370.07 471.63"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '397.82000732421875px 475.2200012207031px',
          }}
          id="el3v30r0xwvph"
          className="animable"
        />
        <path
          d="M395.23,429.3c-.13,0-.3-22.39-.38-50s0-50,.1-50,.31,22.38.38,50S395.37,429.29,395.23,429.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '395.09185299277306px 379.29998779296875px',
          }}
          id="elv93cyuxqac"
          className="animable"
        />
        <path
          d="M410.39,373.28a3.17,3.17,0,0,1-.18.52l-.61,1.45c-.14.32-.29.66-.45,1l-.45,1.27c-.16.46-.34.95-.52,1.46s-.33,1.08-.51,1.66a68.76,68.76,0,0,0-1.9,8.33,101.05,101.05,0,0,0-1,10.42,142.32,142.32,0,0,0,.53,19c.22,2.43.44,4.39.61,5.75.07.63.12,1.15.17,1.56a2.08,2.08,0,0,1,0,.55,4,4,0,0,1-.12-.53c-.07-.41-.15-.93-.26-1.56-.22-1.35-.49-3.31-.76-5.74a126.39,126.39,0,0,1-.68-19.08,96,96,0,0,1,1.1-10.47,63.54,63.54,0,0,1,2-8.36c.19-.58.34-1.14.54-1.66s.38-1,.56-1.45l.49-1.27c.17-.38.34-.72.49-1l.69-1.41A2,2,0,0,1,410.39,373.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '407.2745406627655px 399.7649841308594px',
          }}
          id="el12n7ajdj0i8m"
          className="animable"
        />
        <path
          d="M408.65,355.17a5.25,5.25,0,0,1-.22.74l-.71,2.08c-.15.46-.33,1-.52,1.5s-.35,1.16-.54,1.81c-.4,1.3-.86,2.77-1.27,4.42l-.69,2.59c-.2.91-.41,1.85-.63,2.83-.48,1.95-.82,4.07-1.26,6.28-.75,4.44-1.41,9.36-1.87,14.54s-.61,10.15-.68,14.66,0,8.57.23,12c.06,1.71.17,3.25.26,4.6s.16,2.52.25,3.47.12,1.64.16,2.19a3.73,3.73,0,0,1,0,.77,3.92,3.92,0,0,1-.12-.76c-.07-.54-.15-1.27-.26-2.18s-.23-2.12-.33-3.47-.25-2.89-.33-4.6c-.23-3.41-.32-7.48-.34-12s.22-9.5.65-14.7,1.13-10.13,1.91-14.58c.45-2.22.81-4.34,1.3-6.29.23-1,.46-1.92.67-2.83l.72-2.59c.43-1.65.91-3.12,1.34-4.41.21-.64.4-1.24.58-1.8l.57-1.49.79-2.05A4.76,4.76,0,0,1,408.65,355.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '404.2144455909729px 392.4099884033203px',
          }}
          id="elaloz3cmf1vu"
          className="animable"
        />
        <path
          d="M390.93,433.26a1.14,1.14,0,0,1,0-.27c0-.2,0-.45-.07-.77,0-.71-.11-1.7-.2-3-.16-2.61-.39-6.33-.68-10.9-.59-9.21-1.44-21.93-3-35.91-.79-7-1.71-13.63-2.66-19.65-.51-3-1-5.87-1.49-8.53s-1-5.14-1.47-7.39-.95-4.29-1.35-6.08-.78-3.32-1.09-4.57l-.71-2.88c-.07-.31-.13-.56-.17-.75a2,2,0,0,1-.05-.27,1.46,1.46,0,0,1,.1.25c.05.2.12.44.21.74l.8,2.87c.35,1.24.75,2.77,1.17,4.55s.95,3.8,1.42,6.06,1,4.73,1.53,7.4,1,5.52,1.54,8.53c1,6,1.91,12.67,2.7,19.67,1.55,14,2.35,26.72,2.85,35.94.25,4.6.43,8.33.53,10.91.05,1.26.09,2.25.11,3l0,.77A1.17,1.17,0,0,1,390.93,433.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '384.47069787979126px 382.7750244140625px',
          }}
          id="elsgktwipe2u"
          className="animable"
        />
        <path
          d="M394.68,340.07c-.3-3.17-3.5-5.57-6.69-5.6a10.54,10.54,0,0,0-8.1,4.4,25.34,25.34,0,0,0-3.9,8.66c-2.15,7.47-3.32,15.32-2.4,23s4.05,15.31,9.59,20.77c.9.88,2.06,1.77,3.3,1.51a4,4,0,0,0,1.74-1.08A51.53,51.53,0,0,0,405,352.56c-.08-2.93-.47-6-2.09-8.43s-5.42-5-8.18-4.06"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '389.1426134109497px 363.6629581451416px',
          }}
          id="eldfinql3njn5"
          className="animable"
        />
        <path
          d="M370.89,314.67l-4.48,8.12c-.11.19-.24.4-.46.42s-.41-.2-.54-.4l-11.86-18.2,2.73-1.55Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '362.2200164794922px 313.1356611251831px',
          }}
          id="elw87p6j3a7sn"
          className="animable"
        />
        <g id="elhi8zqj536ai">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '362.2200164794922px 313.1356611251831px',
            }}
            className="animable"
          >
            <path
              d="M370.89,314.67l-4.48,8.12c-.11.19-.24.4-.46.42s-.41-.2-.54-.4l-11.86-18.2,2.73-1.55Z"
              id="el9vp74dy9bko"
              style={{
                transformOrigin: '362.2200164794922px 313.1356611251831px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M395,329.31,354.5,305.44a1.93,1.93,0,0,1-1-1c-.16-.6.29-1.17.72-1.62a27.87,27.87,0,0,1,21.62-8.49,24.69,24.69,0,0,1,19.54,12.15c3.91,7,4,16.2-.44,22.83"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '375.8797779083252px 311.7984104156494px',
          }}
          id="elxljn458vhdc"
          className="animable"
        />
        <path
          d="M360.33,297.82a2,2,0,0,1,.53-.07c.35,0,.86-.08,1.53-.07a29.78,29.78,0,0,1,5.61.44,32.79,32.79,0,0,1,26.18,23.69,29.94,29.94,0,0,1,1,5.55,10.76,10.76,0,0,1,.07,1.17,2.06,2.06,0,0,1-.32.89,6.54,6.54,0,0,0,.07-2,34.59,34.59,0,0,0-1.15-5.47,33,33,0,0,0-25.91-23.45,35.14,35.14,0,0,0-5.56-.6C361.06,297.84,360.33,297.86,360.33,297.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.78997802734375px 313.54802227020264px',
          }}
          id="elp48u9nzmxx"
          className="animable"
        />
        <path
          d="M389.47,312.83a9.56,9.56,0,0,1-2,.93c-1.29.51-3.09,1.16-5.11,1.8s-3.86,1.15-5.2,1.48a10.68,10.68,0,0,1-2.21.42,10.9,10.9,0,0,1,2.12-.76l5.15-1.6,5.13-1.66A11.2,11.2,0,0,1,389.47,312.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.2100067138672px 315.1449890136719px',
          }}
          id="elcdicrv72bgm"
          className="animable"
        />
        <path
          d="M383.1,295.72a28.18,28.18,0,0,1,.23,9,28.8,28.8,0,0,1-.23-4.52A29.82,29.82,0,0,1,383.1,295.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '383.3008479177952px 300.2200012207031px',
          }}
          id="eluiqumha6te9"
          className="animable"
        />
        <path
          d="M354.14,305a19,19,0,0,1,2.94-1c1.84-.57,4.4-1.28,7.25-2s5.46-1.22,7.36-1.55a19.17,19.17,0,0,1,3.08-.42,20.44,20.44,0,0,1-3,.76c-1.87.41-4.46,1-7.3,1.68s-5.42,1.35-7.27,1.83A20.79,20.79,0,0,1,354.14,305Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '364.4550018310547px 302.51499938964844px',
          }}
          id="elfj8zf59wle"
          className="animable"
        />
        <path
          d="M377.89,333.19c-3.48-2.64-7.16-3.16-11.53-3a35.16,35.16,0,0,0-12.6,3.26c-6.83,3-13.24,7.39-17.31,13.62S331,361.56,334,368.36a3,3,0,0,0,1.39,1.67,3.29,3.29,0,0,0,2.28-.17c7.76-2.53,15.57-5.09,22.7-9.05s13.63-9.47,17.46-16.68a14.29,14.29,0,0,0,1.84-5.54,6.87,6.87,0,0,0-1.78-5.4"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '356.04673957824707px 350.16115379333496px',
          }}
          id="elszc4mqmhmm"
          className="animable"
        />
        <path
          d="M378,332.37a2.49,2.49,0,0,1-.55.23l-1.63.55-1.18.4c-.42.15-.88.34-1.37.53-1,.4-2.12.8-3.32,1.38l-1.91.87c-.65.3-1.31.67-2,1-1.41.69-2.83,1.57-4.34,2.47a68.41,68.41,0,0,0-17.12,15.06c-1.08,1.39-2.14,2.68-3,4-.44.65-.9,1.25-1.28,1.87s-.75,1.21-1.11,1.77c-.73,1.12-1.27,2.2-1.78,3.12-.26.47-.5.9-.71,1.3l-.54,1.12-.76,1.54a2.22,2.22,0,0,1-.3.52,3.86,3.86,0,0,1,.21-.56l.68-1.58.5-1.14c.2-.41.43-.85.68-1.32.49-.94,1-2,1.73-3.17.34-.58.71-1.18,1.08-1.8s.83-1.24,1.27-1.9c.85-1.32,1.9-2.64,3-4a72.91,72.91,0,0,1,8-8.32,71.46,71.46,0,0,1,9.27-6.83c1.53-.89,3-1.77,4.39-2.45.71-.35,1.38-.71,2-1l1.93-.84c1.22-.57,2.37-.95,3.36-1.32.5-.18,1-.36,1.4-.5l1.19-.35,1.66-.48A2.61,2.61,0,0,1,378,332.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '356.550048828125px 351.23497009277344px',
          }}
          id="el4fjmi7oh4ss"
          className="animable"
        />
        <path
          d="M350.77,347.09a79.88,79.88,0,0,1-8.46,2.72,84.69,84.69,0,0,1-8.6,2.27,81.19,81.19,0,0,1,8.46-2.73A81.36,81.36,0,0,1,350.77,347.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.239990234375px 349.58502197265625px',
          }}
          id="elaao9pdqdi1m"
          className="animable"
        />
        <path
          d="M350.43,365.76a12.42,12.42,0,0,1-.19-2.63c-.05-1.63-.05-3.89,0-6.38s.2-4.73.34-6.36a12.73,12.73,0,0,1,.33-2.62,14.5,14.5,0,0,1,0,2.64c-.06,1.79-.12,4-.2,6.36s-.11,4.57-.16,6.36A16.28,16.28,0,0,1,350.43,365.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '350.5863609313965px 356.7650451660156px',
          }}
          id="el42lfgichqta"
          className="animable"
        />
        <path
          d="M366.42,357.61c-.13,0-.56-4.57-.95-10.22s-.6-10.26-.46-10.27.56,4.57.95,10.23S366.56,357.6,366.42,357.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '365.714996278286px 347.3649682998657px',
          }}
          id="el5tpc1pf6tcy"
          className="animable"
        />
        <path
          d="M346.51,336.68a15,15,0,0,1,2.71-.08c1.67,0,4,.06,6.53.14s4.86.19,6.53.29a14.88,14.88,0,0,1,2.7.26,14.88,14.88,0,0,1-2.71.08c-1.67,0-4-.06-6.53-.14s-4.86-.19-6.53-.29A14.88,14.88,0,0,1,346.51,336.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '355.74501037597656px 336.98525950312614px',
          }}
          id="elsoyide1npe"
          className="animable"
        />
        <path
          d="M384.91,392.4a2.5,2.5,0,0,1-.06-.54c0-.41,0-.92-.07-1.56-.06-1.35-.07-3.31,0-5.73s.21-5.29.5-8.48.77-6.68,1.42-10.32,1.48-7.07,2.3-10.16,1.72-5.85,2.53-8.14,1.51-4.12,2-5.36l.62-1.44a2.68,2.68,0,0,1,.24-.49,2.22,2.22,0,0,1-.15.53c-.14.38-.32.86-.53,1.46-.48,1.27-1.13,3.12-1.9,5.41s-1.59,5.05-2.41,8.14-1.59,6.51-2.26,10.14S386,373,385.7,376.13s-.51,6-.6,8.46S385,389,385,390.3c0,.63,0,1.15,0,1.56A2.1,2.1,0,0,1,384.91,392.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '389.56056022644043px 366.28997802734375px',
          }}
          id="ela9u0zjl1shj"
          className="animable"
        />
        <path
          d="M387.05,365.91a11.49,11.49,0,0,1-1.62,1.78c-1.05,1-2.53,2.44-4.23,3.93s-3.28,2.77-4.45,3.68a10.42,10.42,0,0,1-2,1.36,13.61,13.61,0,0,1,1.75-1.63l4.35-3.78,4.32-3.81A13.06,13.06,0,0,1,387.05,365.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '380.8999786376953px 371.2849884033203px',
          }}
          id="eldup9e7kshm"
          className="animable"
        />
        <path
          d="M399.85,376.23a18.27,18.27,0,0,1-1.72-2.38c-1.1-1.62-2.48-3.62-4-5.84l-4.08-5.77a18.34,18.34,0,0,1-1.63-2.44,16.55,16.55,0,0,1,1.91,2.23c1.12,1.43,2.62,3.44,4.2,5.71s2.94,4.38,3.89,5.92A15.33,15.33,0,0,1,399.85,376.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '394.135009765625px 368.01499938964844px',
          }}
          id="elsqc4r5bbls"
          className="animable"
        />
        <path
          d="M393.14,343.79c.07.11-4.18,3-9.5,6.4s-9.69,6.1-9.76,6,4.18-3,9.5-6.39S393.07,343.68,393.14,343.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '383.51000785827637px 349.9897527694702px',
          }}
          id="el15zc0kmi6o1"
          className="animable"
        />
        <path
          d="M405.14,356.74a157.37,157.37,0,0,1-12.53-12.24,157.27,157.27,0,0,1,12.53,12.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '398.87501525878906px 350.6199951171875px',
          }}
          id="elvqxwajdgjwq"
          className="animable"
        />
        <path
          d="M408.15,356.48l3.65-.31a18.13,18.13,0,0,0,7.38-2.25,29.76,29.76,0,0,1,3.43-1.73c4.52-1.81,9.55-1.49,14.41-1.73A59.72,59.72,0,0,0,460,344.6a2.24,2.24,0,0,0,1-.91c.76-1.37-.64-2.58-1.84-3.32-6.15-3.79-12.41-7.63-19.39-9.51s-14.89-1.57-20.84,2.53c-7,4.81-9.54,14.69-10.72,23.09"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '434.6828498840332px 343.1166305541992px',
          }}
          id="el8ynaslnd78h"
          className="animable"
        />
        <path
          d="M461,343.24a2.75,2.75,0,0,1-.62-.29l-1.73-.9c-1.5-.79-3.66-2-6.39-3.27a61,61,0,0,0-9.9-3.81,32.67,32.67,0,0,0-12.82-1,22,22,0,0,0-11.7,5,26,26,0,0,0-6.08,8.55,68.92,68.92,0,0,0-2.65,6.66l-.65,1.84a2.69,2.69,0,0,1-.26.63,4.13,4.13,0,0,1,.17-.66c.14-.47.33-1.09.56-1.87a59.74,59.74,0,0,1,2.52-6.74,25.65,25.65,0,0,1,6.1-8.74,22.18,22.18,0,0,1,11.92-5.17,32.6,32.6,0,0,1,13,1.09,57.47,57.47,0,0,1,9.93,3.94c2.72,1.35,4.85,2.56,6.33,3.4l1.69,1A4.2,4.2,0,0,1,461,343.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '434.5999755859375px 344.9470376968384px',
          }}
          id="elhaie8jt8gzo"
          className="animable"
        />
        <path
          d="M452.26,348c-.08.11-4.85-3-10.67-6.9s-10.47-7.19-10.39-7.3,4.85,3,10.66,6.9S452.33,347.84,452.26,348Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '441.7298860549927px 340.90000104904175px',
          }}
          id="elnuofkucslgd"
          className="animable"
        />
        <path
          d="M447.16,333.5a11.34,11.34,0,0,1-3.47.63,11.79,11.79,0,0,1-3.55-.05,22,22,0,0,1,3.51-.36A24.53,24.53,0,0,1,447.16,333.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '443.65000915527344px 333.86974734067917px',
          }}
          id="eln7c2jbmrq8h"
          className="animable"
        />
        <path
          d="M426.26,330.78a9.45,9.45,0,0,1-1.57,2.44,10.84,10.84,0,0,1-2,2.26,9,9,0,0,1,1.57-2.45A10,10,0,0,1,426.26,330.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '424.4750061035156px 333.12998962402344px',
          }}
          id="eld8zurlrczk"
          className="animable"
        />
        <path
          d="M430.54,350.77a13.13,13.13,0,0,1-2.3-1.25c-1.38-.84-3.24-2.06-5.24-3.51s-3.74-2.82-5-3.82a13.44,13.44,0,0,1-2-1.7,14.3,14.3,0,0,1,2.19,1.43l5.09,3.7c2,1.44,3.81,2.7,5.14,3.61A16.5,16.5,0,0,1,430.54,350.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '423.27000427246094px 345.6299743652344px',
          }}
          id="elsa08qnp22kp"
          className="animable"
        />
        <path
          d="M413.53,372c-3.48-.92-7.64,2.47-8.35,6s.6,7.14,2.15,10.39a53,53,0,0,0,14.4,18.84,35.64,35.64,0,0,0,22,8.11c-1.48-6.84.39-14-.44-20.93a27.24,27.24,0,0,0-24.11-23.88c-2.22-.24-4.79-.58-5.68,1.47"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '424.3559150695801px 392.84399032592773px',
          }}
          id="elzqbjtmn9e3s"
          className="animable"
        />
        <path
          d="M443.76,415.33a3.13,3.13,0,0,1-.5-.23,8.73,8.73,0,0,1-1.3-.88,13.51,13.51,0,0,1-3.44-4.59c-.56-1.08-1.18-2.25-1.78-3.55l-1.88-4.14a39.08,39.08,0,0,0-2.3-4.43,34.73,34.73,0,0,0-3.17-4.31c-2.38-2.8-4.94-5.22-7.16-7.54a48.8,48.8,0,0,1-5.46-6.55A23.91,23.91,0,0,1,414.1,374c-.22-.65-.38-1.15-.46-1.5a1.93,1.93,0,0,1-.11-.53s.24.71.75,2a26.23,26.23,0,0,0,2.77,5,51.88,51.88,0,0,0,5.5,6.43c2.23,2.29,4.8,4.71,7.21,7.54a35.18,35.18,0,0,1,3.21,4.37,41.55,41.55,0,0,1,2.3,4.49c.64,1.47,1.26,2.86,1.83,4.16s1.19,2.47,1.72,3.56a14.06,14.06,0,0,0,3.26,4.61C443.1,415,443.78,415.28,443.76,415.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '428.64524936676025px 393.65000915527344px',
          }}
          id="elowiasbpd7i"
          className="animable"
        />
        <path
          d="M425.75,409.65a9.57,9.57,0,0,1,.32-2.35c.27-1.43.72-3.4,1.32-5.55s1.25-4.05,1.77-5.42a10.19,10.19,0,0,1,.95-2.17,13.44,13.44,0,0,1-.63,2.28c-.43,1.39-1,3.31-1.62,5.45s-1.1,4.08-1.46,5.49A14.33,14.33,0,0,1,425.75,409.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '427.9299774169922px 401.90501403808594px',
          }}
          id="elkmaryqvj4"
          className="animable"
        />
        <path
          d="M443.1,392.86a13.78,13.78,0,0,1-2.46-.56c-1.5-.4-3.57-.93-5.88-1.45s-4.4-.93-5.93-1.21a14.07,14.07,0,0,1-2.46-.55,11.92,11.92,0,0,1,2.52.21c1.54.2,3.66.55,6,1.07s4.39,1.12,5.87,1.6A11.51,11.51,0,0,1,443.1,392.86Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '434.73500061035156px 390.9734025001526px',
          }}
          id="elxohpjns0a0h"
          className="animable"
        />
        <path
          d="M412.82,397.74a14.39,14.39,0,0,1,.38-2.72c.31-1.66.79-3.94,1.44-6.44s1.35-4.73,1.89-6.33a14.58,14.58,0,0,1,1-2.55,16.15,16.15,0,0,1-.67,2.65c-.46,1.62-1.1,3.86-1.75,6.35s-1.18,4.75-1.58,6.39A16.43,16.43,0,0,1,412.82,397.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '415.1750183105469px 388.7200164794922px',
          }}
          id="el8uqidspe51r"
          className="animable"
        />
        <path
          d="M435.11,378.23c0,.13-4.37-.22-9.71-.79s-9.68-1.13-9.66-1.26a97.07,97.07,0,0,1,9.71.78C430.8,377.53,435.12,378.1,435.11,378.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '425.42496967315674px 377.21854770183563px',
          }}
          id="eldos0xocus2b"
          className="animable"
        />
        <path
          d="M431.92,431c0,.13-15.28.24-34.13.24s-34.14-.11-34.14-.24,15.28-.25,34.14-.25S431.92,430.82,431.92,431Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '397.78501892089844px 430.9949951171875px',
          }}
          id="el8cg16xnovax"
          className="animable"
        />
        <path
          d="M421.29,450.62c0,.14-10.3.25-23,.25s-23-.11-23-.25,10.3-.24,23-.24S421.29,450.49,421.29,450.62Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '398.2900085449219px 450.625px',
          }}
          id="elycrd8gacn7"
          className="animable"
        />
        <path
          d="M420.89,453.44c0,.13-10.12.24-22.6.24s-22.6-.11-22.6-.24,10.12-.25,22.6-.25S420.89,453.3,420.89,453.44Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '398.2900085449219px 453.43499755859375px',
          }}
          id="elv1uju01hnt9"
          className="animable"
        />
        <path
          d="M421.69,448.31c0,.13-10.65.24-23.79.24s-23.79-.11-23.79-.24,10.65-.25,23.79-.25S421.69,448.17,421.69,448.31Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '397.8999938964844px 448.30499267578125px',
          }}
          id="el1fho27yc3s2j"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-3"
        style={{ transformOrigin: '291.2563018798828px 75.85684394836426px' }}
        className="animable"
      >
        <path
          d="M285,47.2c-8.92-2-20.37,4.2-23.45,12.54s.26,18.66,7,24.49c-5.24,6.74-5.46,16.76-1,24.06s13,11.68,21.55,11.63a30.32,30.32,0,0,0,22.37-10.78,21.87,21.87,0,0,0,31.17-23.6C352.72,81.85,358.28,68.92,354,59s-17.52-14.67-27.13-9.81c.21-10.77-9.18-20.82-19.94-21.34S285.85,36.46,285,47.2h0"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '307.9262580871582px 73.8746223449707px',
          }}
          id="eld4i3fbzxt4e"
          className="animable"
        />
        <path
          d="M285,47.2l-.15,0h0c0-.05,0,0,0,0h.06l.14,0,.16,0c0,.08-.11,0-.17.07h0v0A19.31,19.31,0,0,1,286.53,41a21.93,21.93,0,0,1,3.06-5,22.58,22.58,0,0,1,5.63-5,20.72,20.72,0,0,1,8.5-3.08l1.23-.14h1.27a19.15,19.15,0,0,1,2.59.19A19.92,19.92,0,0,1,314,29.47a9.3,9.3,0,0,1,1.27.62c.41.23.84.45,1.25.7a24.16,24.16,0,0,1,2.37,1.72,28.21,28.21,0,0,1,2.22,2,28.61,28.61,0,0,1,1.94,2.4,20.73,20.73,0,0,1,4,12.27l-.3-.19A20,20,0,0,1,341,47.92a20.63,20.63,0,0,1,12.31,9.21,19.41,19.41,0,0,1,1.13,16.23A22,22,0,0,1,350,80.79a18.82,18.82,0,0,1-7.3,5l.17-.29a22.42,22.42,0,0,1-1.45,12.59,21.85,21.85,0,0,1-8.34,10,22.71,22.71,0,0,1-21.75,1.25l.31-.06a31.25,31.25,0,0,1-18.27,10.48,26.27,26.27,0,0,1-19.27-4.27,23.69,23.69,0,0,1-6.6-6.83,21.94,21.94,0,0,1-3.08-8.55,22.56,22.56,0,0,1,.42-8.65,20.4,20.4,0,0,1,3.55-7.38l0,.27a24.55,24.55,0,0,1-6.78-10.11,22.74,22.74,0,0,1-1.25-5.5,20,20,0,0,1,.09-5.31,16.48,16.48,0,0,1,3.87-8.62,22.94,22.94,0,0,1,6.21-5.05,24.64,24.64,0,0,1,5.95-2.39,20.56,20.56,0,0,1,4.66-.62,15.24,15.24,0,0,1,2.89.23c.64.11,1,.19,1,.19l-1-.13a16.22,16.22,0,0,0-2.88-.17,20.67,20.67,0,0,0-4.62.67A24.61,24.61,0,0,0,270.66,50a22.81,22.81,0,0,0-6.11,5,16.21,16.21,0,0,0-3.76,8.49,19.75,19.75,0,0,0-.08,5.22A23.12,23.12,0,0,0,262,74.15a24.11,24.11,0,0,0,6.7,9.93l.14.12-.11.15a20,20,0,0,0-3.46,7.24,22.33,22.33,0,0,0-.4,8.49,21.61,21.61,0,0,0,3,8.37,23.26,23.26,0,0,0,6.48,6.68,25.84,25.84,0,0,0,18.92,4.17,30.78,30.78,0,0,0,18-10.33l.13-.15.18.09a22.22,22.22,0,0,0,21.24-1.23,21.38,21.38,0,0,0,8.14-9.81,21.72,21.72,0,0,0,1.42-12.29l0-.21.21-.07A19.94,19.94,0,0,0,354,73.2a18.87,18.87,0,0,0-1.07-15.82,20.18,20.18,0,0,0-12-9A19.51,19.51,0,0,0,327,49.41l-.31.15v-.34a20.38,20.38,0,0,0-3.9-12,27.85,27.85,0,0,0-1.91-2.37,25.57,25.57,0,0,0-2.17-2,23.45,23.45,0,0,0-2.33-1.7c-.41-.25-.82-.47-1.23-.7a9.69,9.69,0,0,0-1.25-.62,19.87,19.87,0,0,0-5.11-1.55,20.14,20.14,0,0,0-2.54-.19H305l-1.22.13a20.31,20.31,0,0,0-8.39,3A22.44,22.44,0,0,0,286.67,41,20.38,20.38,0,0,0,285,47.2l0,0c.07,0,.16-.07.19,0l-.17,0-.13,0h-.07s0,0,0,0H285Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '307.9647979736328px 73.95289039611816px',
          }}
          id="elmdhf214im9"
          className="animable"
        />
        <path
          d="M301.81,91.32a11.16,11.16,0,0,0,6.86,1.38,10.77,10.77,0,0,0,7.12-4.43,10.08,10.08,0,0,0,1.86-7.66,9.92,9.92,0,0,0-4.53-6.46,10.77,10.77,0,0,0-6.27-1.7l.18-9a1.6,1.6,0,0,0-3.19-.07l-.23,10.92a1.62,1.62,0,0,0,.61,1.29,1.58,1.58,0,0,0,1.39.29,7.36,7.36,0,0,1,5.8,1,6.74,6.74,0,0,1,3.1,4.34,6.85,6.85,0,0,1-1.32,5.21,7.49,7.49,0,0,1-5,3.13c-3.8.53-8-2.29-9.12-6.15a1.6,1.6,0,0,0-3.07.91A12.15,12.15,0,0,0,301.81,91.32Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '306.85896587371826px 77.3585319519043px',
          }}
          id="el14xv9602w9dh"
          className="animable"
        />
        <path
          d="M307.64,56.86a1.8,1.8,0,1,0-1.88,1.71A1.8,1.8,0,0,0,307.64,56.86Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '305.84214758872986px 56.77187883853912px',
          }}
          id="elmy9mgq7b8rj"
          className="animable"
        />
        <path
          d="M248.24,97.22a8.74,8.74,0,1,0,7.72,9.69,9.09,9.09,0,0,0-7.72-9.69"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '247.26215267181396px 105.90689182281494px',
          }}
          id="el4yils21oed7"
          className="animable"
        />
        <path
          d="M248.29,97.23a6.11,6.11,0,0,1,2.1.45,9.4,9.4,0,0,1,5.8,7.61,8.19,8.19,0,0,1-.93,4.59,9,9,0,0,1-1.5,2.07,9.21,9.21,0,0,1-2.09,1.66,8.34,8.34,0,0,1-10.4-1.19,8.69,8.69,0,0,1-1.66-2.09,8.49,8.49,0,0,1-1-2.35,8.06,8.06,0,0,1,.13-4.68,9.37,9.37,0,0,1,7.36-6.11,5.94,5.94,0,0,1,2.14,0c0,.07-.77-.06-2.11.17a9.23,9.23,0,0,0-4.95,2.71,8.75,8.75,0,0,0-2,3.33,7.7,7.7,0,0,0-.08,4.42,9.13,9.13,0,0,0,2.55,4.2,7.88,7.88,0,0,0,9.79,1.12,8.52,8.52,0,0,0,2-1.57,8.36,8.36,0,0,0,1.43-1.95,7.62,7.62,0,0,0,.93-4.32,9,9,0,0,0-1.23-3.71,9.29,9.29,0,0,0-4.21-3.75A17.6,17.6,0,0,0,248.29,97.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '247.27390480041504px 105.99845504760742px',
          }}
          id="elnsvdxkbjrf"
          className="animable"
        />
        <path
          d="M231.22,116.24a3.77,3.77,0,1,0,3.33,4.18,3.92,3.92,0,0,0-3.33-4.18"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '230.79824090003967px 119.98708653450012px',
          }}
          id="elda3sfb9dghh"
          className="animable"
        />
        <path
          d="M231.24,116.25a1.64,1.64,0,0,1,.93.14,4.08,4.08,0,0,1,2.6,3.32,3.64,3.64,0,0,1-.41,2.06,4,4,0,0,1-7.43-.85,3.64,3.64,0,0,1,.07-2.1,4.12,4.12,0,0,1,1-1.52,4,4,0,0,1,2.3-1.13,1.83,1.83,0,0,1,.94.07c0,.05-.34,0-.9.13a4.08,4.08,0,0,0-2.07,1.19,3.32,3.32,0,0,0-.85,3.23,3.49,3.49,0,0,0,6.54.75,3.32,3.32,0,0,0-.1-3.34,3.88,3.88,0,0,0-1.75-1.62C231.57,116.33,231.23,116.29,231.24,116.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.79749989509583px 120.03603935241699px',
          }}
          id="elspo2tkqpl2h"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FAQIcon;

FAQIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
